import { useContext, useEffect } from "react";
import { useLocation, useMatches } from "react-router-dom";
import { PageHeadingContext } from "@osu/react-ui"
import { APPLICATION_NAME } from "../../../util/constants";

export const changeDocumentTitle = (pageTitle) => {
    const newTitle = (pageTitle && !pageTitle.includes(APPLICATION_NAME)) ? `${pageTitle} | ${APPLICATION_NAME}` : APPLICATION_NAME
    if (newTitle && document.title !== newTitle) {
      document.title = newTitle
    }
    return () => {
      if(document.title !== APPLICATION_NAME) {
        document.title = APPLICATION_NAME
      }
    }
}

function usePageTitleFromRouting() {
  const { pathname } = useLocation();
  const matches = useMatches();
  let matchingPage = undefined;
  matchingPage = matches.find((match) => match.pathname === pathname);
  if (!matchingPage?.handle) {
    matchingPage = [...matches].reverse().find((match) => match.handle);
  }
  const handle = matchingPage?.handle || {};
  const pageHeading = handle?.title;
  const pageTitle = pathname === "/" ? "Home" : pageHeading;

  const { setHeading, setPageTitle } = useContext(PageHeadingContext);
  useEffect(() => {
    if (pageTitle) {
      changeDocumentTitle(pageTitle)
      setPageTitle(pageTitle);
    }
  }, [pageTitle, setPageTitle]);

    useEffect(() => {
    if (pageHeading) {
      setHeading(pageHeading);
    }
  }, [pageHeading, setHeading]);

  return pageTitle;
}

export default usePageTitleFromRouting;
